<template>
  <div>
    <div class="b-page">
      <div class="!bg-transparent">
        <div class="bg-white py-[30px] px-[15px] rounded-[4px]">
          <div class="mb-[30px]">
            <p class="text-[18px] text-[#052532] my-[10px] mx-[5px] mt-0 font-bold text-center">
              GÓI SẢN PHẨM ATOSA - TRỢ LÝ SHOPEE MARKETING
            </p>
          </div>

          <div class="py-0 px-[10px] mb-[20px]">
            <el-tabs v-model="tab">
              <el-tab-pane label="Gói Atosa Shopee Ads" name="shopee_ads">
              </el-tab-pane>
              <!--              <el-tab-pane label="Gói Atosa Agent" name="atosa_agent">-->
              <!--              </el-tab-pane>-->
              <el-tab-pane label="Gói Atosa Nâng cao" name="atosa_advanced">
              </el-tab-pane>
              <el-tab-pane label="Gói Nghiên Cứu Thị Trường" name="shopee_analysis">
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="py-0 px-[10px] pb-[30px]">
            <div
                class="w-full min-h-[300px] flex flex-wrap gap-y-[40px] items-center justify-center rounded-[10px] py-[30px] px-0 bg-gradient-to-br from-[#667eea] to-[#764ba2]">
              <template v-for="key in Object.keys(package_keys)">
                <template v-if="tab === key">
                  <div v-for="(pack, index) in m__get_self_data_from_key(package_keys[key].data_key, [])"
                       :key="pack._id"
                       class="package-item max-w-[500px] py-0 px-[10px] transition-all duration-500 ease-in-out opacity-0"
                       :class="show_package ? 'opacity-100' : ''"
                       :style="{ 'transition-delay': `${(index + 1) * 80}ms` }">
                    <div class="box-border border border-[#E1E1E1] rounded-[8px] relative bg-white">
                      <div
                          class="absolute top-[-10px] left-1/2 -translate-x-1/2 translate-y-0 bg-gradient-to-r from-[#4CAF50] to-[#45a049] text-white py-[4px] px-[10px] rounded-[4px]"
                          v-if="current_pack.extend_package && current_pack.extend_package.length && current_pack.extend_package.find(i => i.package._id === pack._id)">
                        ĐANG DÙNG
                      </div>

                      <div class="py-[30px] px-0 pb-[20px]">
                        <div class="h-[33px] leading-[22px] py-0 px-[30px] text-center">
                          <span class="text-[15px] font-bold">
                            {{ pack.name }}
                          </span>
                        </div>
                        <div class="text-center mt-[12px]">
                          <span class="text-[31px] font-bold text-[orangered]">
                            {{ pack.price | currency }}đ
                          </span>
                          <div class="h-[2px] w-[30%] bg-[orangered] my-[5px] mx-auto"></div>
                        </div>
                        <div class="mt-[40px] py-0 px-[40px]">
                          <component :is="package_keys[key].component_id" :pack="pack"></component>
                        </div>
                        <div class="mt-[40px] py-0 px-[40px]">
                          <el-button type="buy-pack" size="mini" class="full-w btn-buy-pack"
                                     @click="m__try_buy_pack(pack)">
                            Mua Gói
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="!bg-transparent">
        <div class="bg-white min-h-[30vh] py-[30px] px-[25px] pb-[10px] rounded-[4px]">
          <div>
            <div class="text-[15px] font-bold">
              ✅ Gói sản phẩm đang dùng
            </div>

            <div v-if="c__store_current_packages.length" class="mt-[20px]">
              <div class="flex flex-wrap gap-[20px]">
                <div v-for="pack in c__store_current_packages" class="current-package-item">
                  <img src="static/img/logo.png" alt="logo" class="w-[30px] h-[30px] rounded-[50%]">
                  <div class="flex flex-col gap-[5px]">
                    <div>
                      <span class="text-[13px] font-semibold w-full truncate overflow-hidden whitespace-nowrap">
                        {{ pack.package.name }}
                      </span>
                    </div>
                    <div class="flex gap-[8px]">
                      <span class="text-[13px] text-[#999]">Bản quyền đến:</span>
                      <span class="text-[13px] font-bold"
                            :class="pack.valid ? 'text-success' : 'text-danger'">
                        {{ pack.license_to | timeFormat('HH:mm DD/MM/YYYY') }}
                      </span>
                    </div>
                  </div>

                  <div class="hidden-block">
                    <div>
                      Click đúp để xem chi tiết
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="text-[12px] italic text-[#6b7280]">
                Bạn chưa sử dụng gói sản phẩm nào.
              </p>
            </div>
          </div>

          <div class="mt-[50px] mb-[30px]">
            <div class="text-[15px] font-bold">
              📦 Gói sản phẩm đã mua
            </div>

            <div v-if="c__bought_packages_grouped.length" class="mt-[20px]">
              <div class="flex flex-wrap gap-x-[20px] gap-y-[20px]">
                <div v-for="pack in c__bought_packages_grouped" class="bought-package-item">
                  <div class="flex gap-[10px] items-center">
                    <img src="static/img/logo.png" alt="logo" class="w-[30px] h-[30px] rounded-[50%]">
                    <div class="flex flex-col gap-[2px]">
                      <div>
                        <span class="text-[13px] font-semibold">{{ pack.name }}</span>
                      </div>
                      <div class="flex gap-[8px]">
                        <span class="text-[13px] text-[#999]">Số lượng gói:</span>
                        <span class="text-[13px] font-semibold">x{{ pack.quantity }}</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button @click="m__try_apply_package(pack)">
                      Áp dụng gói
                    </button>
                  </div>
                </div>
              </div>

              <div class="mt-[25px]">
                <p class="text-[12px] italic text-[#6b7280]">
                  Khi gói đang dùng hết thời hạn bản quyền, hệ thống sẽ tự lấy gói đã mua để gia hạn. Bạn có thể áp dụng
                  gói đã mua để reset bộ đếm kho và tăng thời hạn bản quyền 1 tháng.
                </p>
              </div>
            </div>
            <div v-else>
              <p class="text-[12px] italic text-[#6b7280]">
                Bạn đang không còn gói trong kho.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="select_shop_dialog" :close-on-click-modal="false"
               custom-class="no-body" width="420px">
      <div slot="title" class="p-[20px]">
        <div class="text-[14px] font-bold pt-[10px] text-center">
          Chọn 1 cửa hàng để áp dụng gói
        </div>

        <div class="mt-[20px] font-semibold overflow-y-scroll pl-[20px] text-center max-h-[calc(100vh-300px)]">
          <el-select size="mini" v-model="selected_shop" placeholder="Chọn cửa hàng" class="w-[230px]" filterable>
            <el-option v-for="shop in shop_list" :key="shop._id" :value="shop._id" :label="shop.username"></el-option>
          </el-select>
        </div>

        <div class="mt-[30px] text-center">
          <button class="payment-button" @click="m__open_payment_with_shop_id();">
            Bắt đầu thanh toán
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderBy as _orderBy } from 'lodash'
import pack_viewer from './pack_viewer'
import ShopeeAdsComponent from './component/shopee_ads_component.vue'
import ShopeeAnalysisComponent from './component/shopee_analysis_component.vue'
import AtosaAgentComponent from './component/atosa_agent_component.vue'
import AtosaAdvancedComponent from './component/atosa_advanced_component.vue'

export default {
  name: 'page__store-pack-2',

  components: {
    pack_viewer,
    ShopeeAdsComponent,
    AtosaAgentComponent,
    AtosaAdvancedComponent,
    ShopeeAnalysisComponent
  },

  data() {
    return {
      tab: 'shopee_ads',
      show_package: false,

      current_pack: {},
      system_pack: [],
      marketing_pack: [],
      analysis_pack: [],
      advanced_pack: [],
      atosa_agent_pack: [],
      tiktok_pack: [],
      bought_package: [],
      buy_package: {
        loading: false,
        show: false,
        pack: {},
        month: 1,
        apply: true,
        type: 'balance',
        balance: 0,
        voucher: ''
      },
      license_as_day: {
        days: 0,
        hours: 0
      },
      show_dialog: {
        package: false
      },
      display_packages: [],
      voucher_code: '',
      voucher_info: {},
      voucher_dialog: false,
      get_voucher: false,
      tab_mapping: {
        shopee_ads: 'shopee_marketing',
        shopee_analysis: 'shopee_analysis,shopee_analysis_spoiler',
        atosa_agent: 'atosa_agent',
        atosa_advanced: 'shopee_shopee_marketing_plan,shopee_marketing_fs'
      },

      shop_list: [],
      selected_shop: null,
      select_shop_dialog: false,

      package_keys: {
        shopee_ads: {
          component_id: 'ShopeeAdsComponent',
          data_key: 'c__marketing_pack_display_list'
        },
        atosa_agent: {
          component_id: 'AtosaAgentComponent',
          data_key: 'atosa_agent_pack'
        },
        atosa_advanced: {
          component_id: 'AtosaAdvancedComponent',
          data_key: 'advanced_pack'
        },
        shopee_analysis: {
          component_id: 'ShopeeAnalysisComponent',
          data_key: 'analysis_pack',
        }
      },
      package_data: []
    }
  },

  async beforeMount() {
    await this.m__get_shop_list()
    await this.m__get_current_pack()
    await this.m__get_package_keys()
    this.m__try_get_bought_package()
    this.m__get_balance()

    await this.$nextTick()
    await this.sleep(10)
    this.show_package = true
  },

  watch: {
    'buy_package.voucher': function () {
      this.m__fill_voucher()
    },

    'buy_package.month': function () {
      if (this.m__get_calculated_total() > this.buy_package.balance) {
        this.buy_package.type = 'payment'
      } else {
        this.buy_package.type = 'balance'
      }
    },

    'tab': async function () {
      this.show_package = false
      await this.$nextTick()
      await this.sleep(10)
      this.show_package = true
    }
  },

  computed: {
    c__marketing_pack_display_list() {
      return _orderBy(this.marketing_pack, ['channel', 'price'], ['desc', 'asc'])
    },

    c__store_current_packages() {
      const result = this.current_pack && this.current_pack.extend_package ? this.current_pack.extend_package : []
      for (const item of result) {
        item.valid = !!this.dayjs().isSameOrBefore(item.license_to);
      }
      return _orderBy(result, ['license_to'], ['desc'])
    },

    c__bought_packages_grouped() {
      return this.bought_package.reduce((result, item) => {
        const found = result.find(i => i._id === item._id)
        if (found) {
          found.quantity++
        } else {
          result.push({
            ...item,
            quantity: 1
          })
        }

        return result
      }, [])
    }
  },

  methods: {
    m__get_self_data_from_key(key, default_value = null) {
      return this[key] || default_value
    },

    m__open_payment_with_shop_id() {
      if (!this.selected_shop) return
      this.open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=${encodeURIComponent(`/payment/transfer?channel=atosa_agent&extra=${JSON.stringify({ shop_id: this.selected_shop })}`)}&token=${this.$store.state.userInfo.token}`)
      this.select_shop_dialog = false
    },

    async m__get_shop_list() {
      const resp = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())
      this.shop_list = resp.body.data

      if (this.shop_list.length === 1) {
        this.selected_shop = this.shop_list[0]._id
      }
    },

    async m__try_apply_package(pack) {
      try {
        let is_extend = false

        if (this.current_pack.extend_package && this.current_pack.extend_package.length) {
          const current_pack = this.current_pack.extend_package.find(i => i.channel === pack.channel)

          if (!current_pack) {
            await this.$confirm(`Bạn có chắc muốn áp dụng 1 gói ${pack.name} [Kênh ${pack.channel}] ngay không?`, {
              type: 'warning',
              confirmButtonText: this.$t('base.confirm'),
              cancelButtonText: this.$t('base.cancel')
            })
          } else if (pack._id === current_pack.package._id) {
            await this.$confirm(`Bạn có chắc muốn áp dụng 1 gói ${pack.name} [Kênh ${pack.channel}] ngay không? Gói bạn đang sử dụng sẽ được cộng thêm 1 tháng, bạn vẫn muốn tiếp tục?`, {
              type: 'warning',
              confirmButtonText: this.$t('base.confirm'),
              cancelButtonText: this.$t('base.cancel')
            })
            is_extend = true
          } else {
            await this.$confirm(`Bạn có chắc muốn áp dụng 1 gói ${pack.name} [Kênh ${pack.channel}] ngay không? Nếu bạn áp dụng gói này, gói ${current_pack.package.name} bạn đang dùng sẽ bị mất, bạn vẫn muốn tiếp tục?`, {
              type: 'warning',
              confirmButtonText: this.$t('base.confirm'),
              cancelButtonText: this.$t('base.cancel')
            })
          }
        } else {
          await this.$confirm(`Bạn có chắc muốn áp dụng 1 gói ${pack.name} [Kênh ${pack.channel}] ngay không?`, {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
        }
        const form = {}
        if (is_extend) {
          form.apply_type = 'extend'
        }
        this.$http.post(this.API.store_set_bought_package.replace('_id', pack._id), form, this.cf())
            .then(resp => {
              this.ntf_s(resp)
              this.m__get_current_pack()
              this.m__try_get_bought_package()
            })
            .catch(error => {
              this.ntf_w(error)
            })
      } catch (e) {
        console.error(e)
      }
    },

    m__get_calculated_total() {
      if (this.voucher_info && this.voucher_info.apply_package_ids &&
          (this.voucher_info.apply_package_ids.length === 0 || this.voucher_info.apply_package_ids.some(i => i === this.buy_package.pack._id))) {

        const price = this.buy_package.month * this.buy_package.pack.price
        const discount = this.voucher_info.discount_value && (price * this.voucher_info.discount_percent / 100) > this.voucher_info.discount_value ? this.voucher_info.discount_value : (price * this.voucher_info.discount_percent / 100)

        if (this.voucher_info.require_order_amount) {
          if (this.buy_package.pack.price * this.buy_package.month >= this.voucher_info.require_order_amount) {
            return price - discount
          } else {
            return this.buy_package.month * this.buy_package.pack.price
          }
        } else {
          return price - discount
        }
      } else {
        return this.buy_package.month * this.buy_package.pack.price
      }
    },

    m__try_buy_pack(pack) {
      console.log(pack)

      if (pack.extra_data && pack.extra_data.required_shop_id) {
        this.select_shop_dialog = true
      } else {
        const channels_view = pack.channel
        this.open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=${encodeURIComponent(`/payment/transfer?channel=${channels_view}&package_id=${pack._id}&extra=${JSON.stringify({ shop_id: this.selected_shop })}`)}&token=${this.$store.state.userInfo.token}`)
      }
    },

    async m__fill_voucher() {
      this.get_voucher = true
      await this.sleep(1000)

      try {
        const voucher_resp = await this.$http.get(`https://api.atosa.asia/api/v1/store/voucher/${this.buy_package.voucher}`, this.cf())
        this.voucher_info = voucher_resp.body.data
        if (this.voucher_info) {
          console.log(this.voucher_info)
        } else {
          this.voucher_info = {}
        }
      } catch (e) {
        this.voucher_info = {}
      } finally {
        this.get_voucher = false
      }
    },

    async m__get_current_pack() {
      const resp = await this.$http.get(this.API.store_get_current_package, this.cf())
      await this.$store.dispatch('set__package', resp.body.data)
      localStorage.setItem('pack', JSON.stringify(resp.body.data))
      this.current_pack = resp.body.data

      const marketing_package = this.current_pack.extend_package.find(i => i.channel === 'shopee_marketing')
      if (marketing_package) {
        if (!this.dayjs().isBefore(this.dayjs(new Date(marketing_package.license_to)), 's')) {
          this.cfm_w('Gói Shopee Marketing của quý khác đã hết hạn. Vui lòng gia hạn gói để tiếp tục sử dụng.')
        }
      }
    },

    async m__get_package_keys() {
      const response = await this.$http.get(this.API.get_system_package_available_shopee_marketing, this.cf())
      this.marketing_pack = response.body.data

      const response_advanced = await this.$http.get(this.API.get_system_package_available_shopee_marketing_advanced, this.cf())
      this.advanced_pack = response_advanced.body.data

      const response_atosa_agent = await this.$http.get(this.API.get_system_package_available_atosa_agent, this.cf())
      this.atosa_agent_pack = response_atosa_agent.body.data

      const response_survey = await this.$http.get(this.API.get_system_package_available_shopee_marketing_survey, this.cf())
      this.analysis_pack = response_survey.body.data

      const tiktok_shop_analysys = await this.$http.get(this.API.get_system_package_available_tiktok_shop_analysis, this.cf())
      this.tiktok_pack = tiktok_shop_analysys.body.data
    },

    m__try_get_bought_package() {
      this.$http.get(this.API.store_get_bought_package, this.cf())
          .then(resp => {
            this.bought_package = resp.body.data.bought_package
            /*.filter(i => ['shopee_marketing', 'shopee_marketing_analysis'].includes(i.channel))*/
          })
          .catch(error => {
            this.ntf_w(error)
          })
    },

    m__get_balance() {
      this.$http.get(this.API.profile, this.cf())
          .then(resp => {
            this.buy_package.balance = resp.body.data.store_current_money
          })
          .catch(error => {
            console.log(error)
          })
    },
  }
}
</script>

<style lang="scss">
@media (min-width: 1600px) {
  .package-item {
    width: 26% !important;
    padding: 0 30px !important;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .package-item {
    width: 32% !important;
    padding: 0 28px !important;
  }
}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {
  .package-item {
    width: 32%;
    padding: 0 30px !important;
  }
}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {
  .package-item {
    width: 50%;
    padding: 0 10px !important;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .package-item {
    width: 80%;
    padding: 0 10px !important;
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .package-item {
    width: 80%;
  }
}

.package-item:hover > div {
  cursor: pointer;
  box-shadow: 2px 4px 8px rgba(45, 45, 48, .2);
  transition: all 0.2s ease;
}

.btn-buy-pack {
  border-radius: 4px;
  background-color: #2563eb !important;
  padding: 10px 0 !important;

  span {
    color: #fff !important;
    font-weight: bold !important;
  }
}

.current-package-item {
  flex: 1 1 calc(25% - 10px);
  max-width: calc(30% - 10px);
  display: flex;
  gap: 10px;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  padding: 10px;
  align-items: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .hidden-block {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(128, 128, 128, 0.9);
    border-radius: 8px;
    transition: all 0.1s ease;

    div {
      width: 100%;
      height: 100%;
      display: flex;
      color: #fff;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 13px;
      user-select: none;
    }
  }

  //&:hover {
  //  .hidden-block {
  //    opacity: 1;
  //    visibility: visible;
  //    transition: all 0.1s ease;
  //  }
  //}
}

.bought-package-item {
  flex: 1 1 calc(45% - 10px);
  max-width: calc(50% - 10px);
  display: flex;
  gap: 10px;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  padding: 10px;
  align-items: center;
  cursor: pointer;
  position: relative;
  justify-content: space-between;

  button {
    background-color: #e5e7eb;
    color: black;
    padding: 5px 14px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    box-shadow: none;
    cursor: pointer;
    font-size: 12px;
    outline: none;
  }

  button:hover {
    background-color: #d1d5db;
  }
}

.payment-button {
  padding: 8px 18px;
  background-color: #ee4d2d;
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 13px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/package/list.vue